import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Components
import CreateKeyset from './createKeyset/createKeyset.constants';
import Layout from '../common/Layout';

// Actions de Redux
import { createHousekey } from '../../redux/housekeys/thunks';
import useScan from '../../hooks/useScan';

const NewHousekeys = () => {
  const navigate = useNavigate();
  // utilizar use dispatch y te crea una función
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-a-hou', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    type_keys_id: '',
    properties_nid: '',
    country: process.env.REACT_APP_ENV_COUNTRY,
    drawers_id: '',
  };

  const submitNewHousekey = (values: any) => {
    dispatch(createHousekey(values))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate(`/housekeys`);
        }
      });
  };

  return (
    <Layout>
      <CreateKeyset onSubmit={submitNewHousekey} />
    </Layout>
  );
  // return (
  //   <Form
  //     submitHousekey={submitNewHousekey}
  //     initialValues={initialValues}
  //     actionText='GUARDAR'
  //   />
  // );
};

export default NewHousekeys;
